import { TypeCommonAPIState } from "@/lib/redux/type";

export function generateInitialStateWithFilter<T, B>(params: { data: T, filter?: B }): TypeCommonAPIState<T> {

  return {
    loading: false,
    success: false,
    error: null,
    data: params.data,
    filter: params.filter || {},
    primaryKeys: [],
    called: false
  }
}